module.exports = __webpack_public_path__ + "static/img/curcumin.d94ea348.jpg";